/* BORN — Displays · v5: bento-hero slider (tabs · autoplay · peek · keys · swipe). Fails open. */
(function () {
  'use strict';
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var each = function (l, f) { Array.prototype.forEach.call(l, f); };

  function initHero5() {
    each(document.querySelectorAll('[data-bn-hero5]'), function (stage) {
      if (stage.dataset.bnBound) return; stage.dataset.bnBound = '1';
      var slides = stage.querySelectorAll('.bn-hero5__slide');
      var tabs = stage.querySelectorAll('.bn-hero5__tab');
      var peek = stage.querySelector('.bn-hero5__peek');
      var peekImg = stage.querySelector('[data-peek-img]');
      var peekTitle = stage.querySelector('[data-peek-title]');
      var n = slides.length; if (n < 2) return;
      var meta = [];
      try { var j = stage.querySelector('[data-hero5-slides]'); if (j) meta = JSON.parse(j.textContent) || []; } catch (e) { meta = []; }
      var i = 0, timer, interval = Math.max(3, parseInt(stage.dataset.interval || '6', 10)) * 1000, hover = false;
      // the active tab's progress line runs for exactly one interval (born-v7.css)
      stage.style.setProperty('--bn-hero-int', interval + 'ms');

      function paint(k, ann) {
        i = ((k % n) + n) % n;
        each(slides, function (s, idx) { s.classList.toggle('is-on', idx === i); s.setAttribute('aria-hidden', String(idx !== i)); });
        each(tabs, function (t, idx) { t.classList.toggle('is-on', idx === i); t.setAttribute('aria-selected', String(idx === i)); t.tabIndex = idx === i ? 0 : -1; });
        var next = meta[(i + 1) % n];
        if (next && peekTitle) {
          peekTitle.textContent = next.title || next.tab || '';
          if (peek) peek.setAttribute('aria-label', 'Next: ' + (next.tab || ''));
          if (peekImg) {
            var im = peekImg.querySelector('img');
            if (next.img) { if (!im) { im = document.createElement('img'); im.alt = ''; peekImg.appendChild(im); } if (im.getAttribute('src') !== next.img) { im.removeAttribute('srcset'); im.removeAttribute('sizes'); im.src = next.img; } }
            else if (im) { im.remove(); }
          }
        }
        // restart the "up next" loader ring so it always tracks the real timer
        var ring = stage.querySelector('.bn-hero5__peek-ring-fg');
        if (ring) { ring.style.animation = 'none'; void ring.getBoundingClientRect(); ring.style.animation = ''; }
        if (ann) { var live = stage.querySelector('[data-hero5-live]'); if (!live) { live = document.createElement('span'); live.setAttribute('data-hero5-live', ''); live.className = 'bn-sr'; live.setAttribute('aria-live', 'polite'); stage.appendChild(live); } live.textContent = (meta[i] && meta[i].tab) ? meta[i].tab + ' — ' + (meta[i].title || '') : ''; }
      }
      function stop() { clearTimeout(timer); }
      function play() { stop(); if (reduced || hover || document.visibilityState !== 'visible') return; timer = setTimeout(function () { paint(i + 1); play(); }, interval); }
      function go(k) { paint(k, true); play(); }

      each(tabs, function (t) { t.addEventListener('click', function () { go(parseInt(t.dataset.go, 10) - 1); }); });
      if (peek) peek.addEventListener('click', function () { go(i + 1); });
      stage.addEventListener('mouseenter', function () { hover = true; stop(); });
      stage.addEventListener('mouseleave', function () { hover = false; play(); });
      stage.addEventListener('focusin', function () { hover = true; stop(); });
      stage.addEventListener('focusout', function (e) { if (!stage.contains(e.relatedTarget)) { hover = false; play(); } });
      stage.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); if (tabs[i]) tabs[i].focus(); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); if (tabs[i]) tabs[i].focus(); }
      });
      // swipe (touch / pen) — a horizontal drag of 40px+ advances
      var sx = null, sy = null;
      stage.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse') return; sx = e.clientX; sy = e.clientY; }, { passive: true });
      stage.addEventListener('pointerup', function (e) { if (sx === null) return; var dx = e.clientX - sx, dy = e.clientY - sy; sx = sy = null; if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) go(dx < 0 ? i + 1 : i - 1); }, { passive: true });
      document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') play(); else stop(); });

      paint(0);
      play();
    });
  }

  function boot() { initHero5(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
